import Vue from 'vue'
//import axios from 'axios'
import Storage from '@/api/localStorage'
import { API_URL } from '@/api/config'
import store from '@/store'
import { helper } from '@/helper'
var ES6Promise = require('es6-promise')
ES6Promise.polyfill()
var axios = require('axios')
// Source code from https://github.com/gothinkster/vue-realworld-example-app
const ApiService = {
  init() {
    Vue.axios.defaults.baseURL = API_URL
  },
  setHeader( token ) {
    // console.log('set headers')
    if ( token ) {
      axios.defaults.headers.common['Authorization'] = token
    } else {
      delete axios.defaults.headers.common['Authorization']
    }
  },
  setHeaderForpost() {
    var clienttype = helper.clienttype()
    if ( clienttype ) {
      if ( Storage.getlocalStorage( 'userData_p' ) ) {
        var localstorage = JSON.parse( Storage.getlocalStorage( 'userData_p' ) ).tokenid
        ApiService.setHeader( localstorage )
      } else {
      }
    }
  },

  post( apiurl, postValue ) {
    // this.setHeaderForpost()
    var apiRequesturl = API_URL + apiurl
    return axios.post( apiRequesturl, postValue )
    /* return axios
       .post(apiRequesturl, postValue)
       .then(response => ({ data }))
       // eslint-disable-next-line to
       .catch(function () {
         throw new Error(`Error in api call `)
       })
       */
  },
  get( apiurl, postValue ) {
    var apiRequesturl = API_URL + apiurl
    return axios.get( apiRequesturl )
    /* return axios
       .post(apiRequesturl, postValue)
       .then(response => ({ data }))
       // eslint-disable-next-line to
       .catch(function () {
         throw new Error(`Error in api call `)
       })
       */
  }
}

export default ApiService
export const userAuthenticat = {
  login( encEmail, localStorageKey ) {
    // console.log('login call goes here ')
    var apiurl = API_URL + 'login'
    return axios
      .post( apiurl, {
        email: encEmail
      } )
      .then( ( response ) => {
        //	console.log(response)
        var keepMe = false

        store.state.auth.isAuthenticated = true
        var userobj = {}
        userobj['email'] = JSON.parse( response.data ).email
        userobj['username'] = JSON.parse( response.data ).username
        store.state.auth.user = userobj
        store.state.auth.errors = {}
        Storage.savelocalStorage( localStorageKey, response.data )
        // ApiService.setHeader(JSON.parse(response.data).tokenid)
        axios.defaults.headers.common['Authorization'] = JSON.parse( response.data ).tokenid
        if ( localStorageKey == 'userData' ) {
          if ( $( '#entitledModal' ).find( "input[name='keepsigned']" ).prop( 'checked' ) == true ) {
            // do something
            keepMe = true
          }
          // if ($('#ks').prop('checked') == true) {
          // 	//do something
          // 	keepMe = true
          // }
          Storage.savelocalStorage( 'keepMe', keepMe )
          window.location.reload( true )
        }
        return true
      } )
      .catch( ( error ) => {
        // console.log(error.response)
      } )
  }
}
export const menus = {
  getheadermenu() {
    return ApiService.get( 'headermenu' )
  },
  getfootermenu() {
    return ApiService.get( 'footer' )
  },
  getlogintext() {
    return ApiService.get( 'loginhelptext' )
  }
}

export const analystforms = {
  contact_analyst( object ) {
    return ApiService.post( 'analystcontact', object )
  },
  get_entitled( object ) {
    return ApiService.post( 'getentitled', object )
  },
  ask_analyat( object ) {
    return ApiService.post( 'askananalyst', object )
  }
}

export const dashboardModules = {
  getthubnail( id ) {
    var requestObj = {}
    requestObj['vimeoid'] = id
    return ApiService.post( 'rvcontent/vimeo', requestObj )
  },

  getfouschart( comparecoid ) {
    var requestObj = {}
    if ( comparecoid ) {
      requestObj['compareco'] = comparecoid
    }
    return ApiService.post( 'focus_list_chart', requestObj )
  },

  getrecentmentions() {
    return ApiService.get( 'rvcontent/dashboard/recentmentioned' )
  },
  getMarketView() {
    var requestObj = {}
    requestObj['category'] = 'market_view'
    return ApiService.post( 'rvcontent/dashboard', requestObj )
  },
  getSectorSummary() {
    var requestObj = {}
    requestObj['category'] = 'sector_summary'
    return ApiService.post( 'rvcontent/dashboard', requestObj )
  },
  getEquityResearch() {
    var requestObj = {}
    requestObj['category'] = 'research_company_and_industry_notes_entitlement'
    return ApiService.post( 'rvcontent/dashboard', requestObj )
  },
  

  getfeaturesiglepost() {
    return ApiService.post( 'featured_third_slot')
  },
  getFocusList() {
    var requestObj = {}
    requestObj['category'] = 'focus_list'
    return ApiService.post( 'rvcontent/dashboard', requestObj )
  },
  getOutlook() {
    var requestObj = {}
    return ApiService.get( 'globaloutlook', requestObj )
  },
  getFocusListSelect() {
    var requestObj = {}
    return ApiService.get( 'focus_list', requestObj )
  },

  getfeature() {
    var requestObj = {}
    requestObj['category'] = 'featured'
    return ApiService.post( 'rvcontent/dashboard', requestObj )
  },
  getdashboardpostwoneuropetoday( category ) {
    var requestObj = {}
    requestObj['category'] = category
    return ApiService.post( 'rvcontent/dashboard', requestObj )
  },
  getdashboardpostderivativesreport( category ) {
    var requestObj = {}
    requestObj['category'] = category
    return ApiService.post( 'rvcontent/dashboard', requestObj )
  },

  yourebooks( category ) {
    var requestObj = {}
    requestObj['category'] = category
    return ApiService.post( 'rvcontent/dashboardyourebook', requestObj )
  },
  getdashboardpost( category ) {
    var requestObj = {}
    requestObj['category'] = category
    return ApiService.post( 'rvcontent/dashboard', requestObj )
  }
}
export const singlePost = {
  getPost( postid ) {
    var requestObj = {}
    requestObj['postid'] = postid
    return ApiService.post( 'rvcontent/post', requestObj )
  }
}
export const searchResult = {
  getfilters() {
    return ApiService.get( 'search/filters' )
  },
  getSearchValue( searchfilters ) {
    // console.log(searchfilters)
    return ApiService.post( 'search', searchfilters )
  },
  analystbio( analystid ) {
    var requestObj = {}
    requestObj['aid'] = analystid
    return ApiService.post( 'analyst_bio', requestObj )
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js